import React from 'react';
import { Grid } from '@material-ui/core';
import SearchSelect from 'react-select';
import RulesDisplay from '../rules/RulesDisplay';
import SaveButton from '../common/SaveButton';
import BackButton from '../common/BackButton';

export default function JourneyRuleSelectMapping({
  selectedRuleObj,
  ruleList,
  setSelectedRuleObj,
  backButton,
  submit,
  classes,
}) {
  const handleMandatory = (ruleConditionId, checked) => {
    setSelectedRuleObj((selectOption) => {
      const mandatoryRuleCoditions = { ...(selectOption.mandatoryRuleCoditions || {}) };
      mandatoryRuleCoditions[ruleConditionId] = checked;

      return {
        ...selectOption,
        mandatoryRuleCoditions,
      };
    });
  };

  return (
    <div>
      <span className={classes.selectRule}>Select Rule</span>
      <SearchSelect
        placeholder="Select Rule"
        value={selectedRuleObj.selectedRule || ruleList[0]}
        onChange={(val) => setSelectedRuleObj({ selectedRule: val, mandatoryRuleCoditions: {} })}
        options={ruleList}
        maxMenuHeight="200px"
        styles={{
          control: (provided) => ({
            ...provided,
            backgroundColor: '#f4f4f4',
          }),
        }}
        getOptionLabel={(option) => option.name}
        getOptionValue={(option) => option.id}
        isClearable={false}
      />
      {selectedRuleObj.selectedRule ? (
        <RulesDisplay
          classes={classes}
          ruleDetails={ruleList.find((i) => i.id === selectedRuleObj.selectedRule?.id)}
          showMandatory
          handleMandatory={handleMandatory}
          mandatoryRuleCoditions={selectedRuleObj?.mandatoryRuleCoditions || {}}
          scrollContentHeight="300px"
        />
      ) : (
        'Select a rule'
      )}
      <span className={classes.horizontalLine}></span>

      <Grid container direction="row" justifyContent="flex-end" style={{ marginTop: '10px' }}>
        <Grid item>
          <BackButton handleBack={backButton} />
        </Grid>
        <Grid item>
          <SaveButton handleSubmit={submit} />
        </Grid>
      </Grid>
    </div>
  );
}
